import { computed, ref } from "vue";
import { hankePage } from "@/views/hanke";
import { ElMessage } from "element-plus";
import { useHakuComponent } from "./haku";
import { HuonekorttiResponse } from "@/api/models/huonekortti-response";

const selectedHuonekortit = ref<HuonekorttiResponse[]>([])
const huonekorttiEditModalVisible = ref(false)

export function useHuonekorttiSelection() {
    const { searchType, searchTotal } = useHakuComponent()
    const { paakayttaja } = hankePage()
    const showMuokkaa = computed(() => {
        return searchType.value == 1 && paakayttaja.value && searchTotal.value > 0
    })

    const showHuonekorttiEditModal = () => {
        if (selectedHuonekortit.value.length === 0) {
            ElMessage.warning("Valitse ensin huonekortit, joita haluat muokata")

            return
        }
        if (selectedHuonekortit.value.length > 50) {
            ElMessage.warning("Voit muokata kerralla korkeintaan 50 huonekorttia")

            return
        }
        huonekorttiEditModalVisible.value = true
    }
    const hideHuonekorttiEditModal = () => {
        huonekorttiEditModalVisible.value = false
    }

    return {
        selectedHuonekortit,
        huonekorttiEditModalVisible,
        showMuokkaa,
        showHuonekorttiEditModal,
        hideHuonekorttiEditModal
    }
}
